package fr.labodoc.healthProfessional.webApp.di

import fr.labodoc.healthProfessional.webApp.data.repository.ContactRepository
import fr.labodoc.healthProfessional.webApp.data.repository.ContactRepositoryImpl
import fr.labodoc.healthProfessional.webApp.data.repository.DepartmentsRepository
import fr.labodoc.healthProfessional.webApp.data.repository.DepartmentsRepositoryImpl
import fr.labodoc.healthProfessional.webApp.data.repository.LaboratoriesRepository
import fr.labodoc.healthProfessional.webApp.data.repository.LaboratoriesRepositoryImpl
import fr.labodoc.healthProfessional.webApp.data.repository.LearnedSocietiesRepository
import fr.labodoc.healthProfessional.webApp.data.repository.LearnedSocietiesRepositoryImpl
import fr.labodoc.healthProfessional.webApp.data.repository.MedicalDiplomasRepository
import fr.labodoc.healthProfessional.webApp.data.repository.MedicalDiplomasRepositoryImpl
import fr.labodoc.healthProfessional.webApp.data.repository.MedicalProfessionsRepository
import fr.labodoc.healthProfessional.webApp.data.repository.MedicalProfessionsRepositoryImpl
import fr.labodoc.healthProfessional.webApp.data.repository.MedicinesRepository
import fr.labodoc.healthProfessional.webApp.data.repository.MedicinesRepositoryImpl
import fr.labodoc.healthProfessional.webApp.data.repository.MessagesRepository
import fr.labodoc.healthProfessional.webApp.data.repository.MessagesRepositoryImpl
import fr.labodoc.healthProfessional.webApp.data.repository.UniversityHospitalsRepository
import fr.labodoc.healthProfessional.webApp.data.repository.UniversityHospitalsRepositoryImpl
import fr.labodoc.healthProfessional.webApp.data.repository.UsersRepository
import fr.labodoc.healthProfessional.webApp.data.repository.UsersRepositoryImpl
import org.koin.dsl.module

val repositoryModule = module {
  single<ContactRepository> {
    ContactRepositoryImpl(
      apiClient = get()
    )
  }

  single<DepartmentsRepository> {
    DepartmentsRepositoryImpl(
      departmentsRemoteDataSource = get()
    )
  }

  single<LaboratoriesRepository> {
    LaboratoriesRepositoryImpl(
      laboratoriesRemoteDataSource = get()
    )
  }

  single<LearnedSocietiesRepository> {
    LearnedSocietiesRepositoryImpl(
      learnedSocietiesRemoteDataSource = get()
    )
  }

  single<MedicalDiplomasRepository> {
    MedicalDiplomasRepositoryImpl(
      medicalDiplomasRemoteDataSource = get()
    )
  }

  single<MedicalProfessionsRepository> {
    MedicalProfessionsRepositoryImpl(
      medicalProfessionRemoteDataSource = get()
    )
  }

  single<MedicinesRepository> {
    MedicinesRepositoryImpl(
      medicinesRemoteDataSource = get()
    )
  }

  single<MessagesRepository> {
    MessagesRepositoryImpl(
      messagesRemoteDataSource = get()
    )
  }

  single<UniversityHospitalsRepository> {
    UniversityHospitalsRepositoryImpl(
      universityHospitalsRemoteDataSource = get()
    )
  }

  single<UsersRepository> {
    UsersRepositoryImpl(
      userRemoteDataSource = get()
    )
  }
}
